// Pushes custom events to the GTM dataLayer for conversion tracking
export const pushGtmEvent = (eventName, params = {}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: eventName, ...params });
};

// Pushes a virtual pageview so SPA route changes are tracked by GTM/GA4
export const pushGtmPageview = (path) => {
  pushGtmEvent("page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
};
